let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eaI3o")).then(() => parcelRequire('f2JIn'));